import { createAction, props } from '@ngrx/store';
import { Feedback, CustomView } from '../../models';
import { KbCategory } from '../../kb/models/kbcategory.model';
import { KbArticle } from 'src/app/kb/models/kbarticle.model';

export const SaveFeedbackRequest = createAction(
    '[Layout] Save Feedback Request', 
    props<{feedback: Feedback}>()
);

export const SaveFeedbackSuccess = createAction(
    '[Layout] Save Feedback Success'
);

export const SaveFeedbackFailed = createAction(
    '[Layout] Save Feedback Failed'
);

export const setShortcut = createAction(
    '[Layout] Set Shortcut', 
    props<{shortcut: string}>()
);

export const TogglePrivateMode = createAction(
    '[Layout] Toggle Message Private Mode'
);

export const GotoArticles = createAction(
    '[Layout] Go to Articles'
);

export const GotoHelpCenter = createAction(
    '[Layout] Go to Help Center'
);

export const setInfoTab = createAction(
    '[Layout] Set Info Tab', 
    props<{tab: string}>()
);


export const scrollToSession = createAction(
    '[Layout] Scroll to Session', 
    props<{id: string}>()
);

export const setTitle = createAction(
    '[Layout] Set Title', 
    props<{title: string, desc: string}>()
);

export const setSelectedProperty = createAction(
    '[Layout] Set Property', 
    props<{id: number}>()
);

export const setSelectedViewMode = createAction(
    '[Layout] Set View Mode', 
    props<{mode: string | number}>()
);

export const persistVisitorSelection = createAction(
    '[Layout] Persist Visitor Selection', 
    props<{visitor_id: string, view: string | number}>()
);

export const persistTicketSelection = createAction(
    '[Layout] Persist Ticket Selection', 
    props<{ticket_id: number, view: string | number}>()
);

export const FocusMessageBox = createAction(
    '[Layout] Focus Message Box',
);

export const setSelectedCategory = createAction(
    '[Layout] Set selected category', 
    props<{category_id: number}>()
);

export const setSelectedArticle = createAction(
    '[Layout] Set selected article', 
    props<{article_id: number}>()
);

export const SearchArticle = createAction(
    '[Layout] Search Article by term', 
    props<{search: string}>()
);

export const ArticlesRequestSuccess = createAction(
    '[Layout] Get Articles by term and category', 
    props<{articles: KbArticle[]}>()
);

export const SingleArticleRequestSuccess = createAction(
    '[Layout] Get Single Article', 
    props<{article: KbArticle}>()
);

export const insertArticle = createAction(
    '[Layout] insert Article in Message', 
    props<{article_id: number}>()
);

export const NewTicketsIndicator = createAction(
    '[Layout] New Tickets Indicator'
);

export const ResetNewTicketsIndicator = createAction(
    '[Layout] Reset New Tickets Indicator'
);

export const HubDisconnected = createAction(
    '[Layout] The Hub was disconnected',
    props<{is_disconnected: boolean}>()
);

export const CustomsViewRequest = createAction(
    '[Layout] Retrieve All Custom View', 
);

export const CustomsViewSuccess = createAction(
    '[Layout] Custom Views Retrieved', 
    props<{custom_views: CustomView[]}>()
);

export const CustomsViewFailed = createAction(
    '[Layout] Custom Views Retrieval Failed', 
    props<{message: string}>()
);


export const SaveViewRequest = createAction(
    '[Layout] Save Custom View Request', 
    props<{custom_view: CustomView}>()
);

export const SaveViewSuccess = createAction(
    '[Layout] Save Custom View Success',
    props<{custom_view: CustomView}>()
);

export const SaveViewFailed = createAction(
    '[Layout] Save Custom Vuew Failed'
);

export const LoadViewRequest = createAction(
    '[Layout] Load Custom View Request', 
    props<{id: number}>()
);

export const LoadViewSuccess = createAction(
    '[Layout] Load Custom View Success',
    props<{custom_view: CustomView}>()
);

export const LoadViewFailed = createAction(
    '[Layout] Load Custom Vuew Failed'
);

export const DeleteViewRequest = createAction(
    '[Layout] Delete Custom View Request', 
    props<{id: number}>()
);

export const DeleteViewSuccess = createAction(
    '[Layout] Delete Custom View Success',
    props<{custom_view: CustomView}>()
);

export const DeleteViewFailed = createAction(
    '[Layout] Delete Custom View Failed'
);

export const HubReconnectRequest = createAction(
    '[Layout] Hub Reconnect Request'
);

export const SetInboxView = createAction(
    '[Layout] Set Inbox View',
    props<{inbox_view: string}>()
);


export const SetSelectedTicket = createAction(
    '[Layout] Set Selected Ticket',
    props<{ticket_id: number | null}>()
);

export const SetTicketViewMode = createAction(
    '[Layout] Change Ticket View Mode',
    props<{view: number}>(),
)